import { util } from 'pevueglobal'
import { router } from '../../router'
import { store } from '@/store/'
import Vue from 'vue'
import {
  setXVtableMutations,
  XVtableSetRowStateProperty,
  XVtableGetRowStateProperty,
  XVtableGetValue,
  XVTablesort,
  XVtablecolumnsettingchanged,
  initXVtableState,
  addXVtableState
} from '../XVtableV2'

import { format } from 'date-fns'

const formInputMessage = {
  subject: '',
  messageBody: ''
}

// state
const state = {
  loading: false,
  srpoTable: {
    tablesetting: {},
    tablecolumnsetting: [],
    tabledata: [],
    rowvisible: []
  },
  srpoTableConcepten: {
    tablesetting: {},
    tablecolumnsetting: [],
    tabledata: [],
    rowvisible: []
  },
  formInput: {
    msBestuur: {},
    rbFunctie: null,
    iStartDatum: null,
    iEindDatum: null,
    cbSchoolvestigingNietAanwezig: false,
    msSchoolvestiging: []
  },
  bevoegdGezagenData: [],
  functieData: [],
  vestigingenData: [],
  formInputConcept: {
    tbxVoorletters: '',
    tbxTussenvoegsel: '',
    tbxAchternaam: '',
    iGeboortedatum: null,
    rbFunctie: null,
    iStartDatum: null
  },
  pageSettings: {
    actieveOvereenkomst: false,
    showConfirm: false,
    showConfirmVerwijder: false,
    showConfirmConceptVerwijder: false,
    selectedOvereenkomstId: 0,
    selectedConceptOvereenkomstId: 0
  },
  btnToggles: {
    btnOpslaan: false,
    btnWijziging: false,
    btnOpslaanConcept: false,
    btnWijzigingConcept: false,
    btnVerstuur: false,
    btnVerwijder: false,
    btnVerwijderConcept: false
  },
  role: {
    schoolleider: false,
    beheerder: false,
    bestuurder: false
  },
  formInputMessage: { ...formInputMessage },
  filterInput: {
    registered: '',
    bestuur: '',
    iBirthDate: null
  }
}

// getters
const getters = {
  loading: state => state.loading,
  srpoTable: state => state.srpoTable,
  srpoTableConcepten: state => state.srpoTableConcepten,
  pageSettings: state => state.pageSettings,
  role: state => state.role,
  formInput: state => state.formInput,
  formInputMessage: state => state.formInputMessage,
  XVtableGetRowStateProperty: XVtableGetRowStateProperty('srpoTable'),
  XVtableGetValue: XVtableGetValue('srpoTable'),
  btnToggles: state => state.btnToggles,
  filterInput: state => state.filterInput,
  bevoegdGezagenData: state => {
    let dlBevoegdGezagenData = state.bevoegdGezagenData.map(bevoegdgezag => ({
      value: bevoegdgezag.nummer,
      labelText: bevoegdgezag.naam + ' (' + bevoegdgezag.nummer + ')'
    }))
    return dlBevoegdGezagenData
  },
  functieData: state => {
    let rblFunctieData = state.functieData.map(functie => ({
      value: functie.id,
      labelText: functie.naam
    }))
    return rblFunctieData
  },
  // is dit zo nog nodig?
  vestigingenData: state => {
    let rblVestigingenData = state.vestigingenData.map(vestiging => ({
      value: vestiging.nummer,
      labelText: vestiging.naam
    }))
    return rblVestigingenData
  }
}

// actions
const actions = {
  getTexten: async ({ dispatch }) => {
    let textIDs = [15450, 14642, 18831, 19783]
    for (var i = 16841; i <= 16897; i++) {
      textIDs.push(i)
    }
    dispatch('gettranslations', textIDs, { root: true })
  },
  getRole: async ({ commit }) => {
    commit('setRole')
  },
  getTableData: async ({ commit }) => {
    state.loading = true
    let where
    if (state.role.beheerder) {
      where = { and: [] }
      if (state.filterInput.bestuur !== '') {
        let or = []
        or.push({ bevoegdGezag: { nummer: { contains: state.filterInput.bestuur } } })
        or.push({ bevoegdGezag: { naam: { contains: state.filterInput.bestuur } } })
        where.and.push({ or: or })
      }
      if (state.filterInput.registered !== '') {
        let or = []
        or.push({ person: { regNr: { contains: state.filterInput.registered } } })
        or.push({ person: { name: { contains: state.filterInput.registered } } })
        where.and.push({ or: or })
      }
      if (state.filterInput.iBirthDate !== null) {
        let or = []
        let dateZ = format(state.filterInput.iBirthDate, 'yyyy-MM-dd') + 'Z'
        or.push({ person: { birthDate: { eq: dateZ } } })
        where.and.push({ or: or })
      }
    } else if (state.role.bestuurder) {
      let yesterday = new Date()
      yesterday.setDate(yesterday.getDate() - 1)

      where = { and: [] }
      let or = []
      or.push({ einddatum: { eq: null } })
      or.push({ einddatum: { gt: format(yesterday, 'yyyy-MM-dd') } })
      where.and.push({ or: or })
    } else {
      where = null
    }
    const query = `query getAgreements($where: OvereenkomstFilterInput, $take: Int, $skip: Int) {
		overeenkomsten(where: $where, take: $take, skip: $skip) {
			items {
				id
				person {
          regNr
					status
					herregDate
					id
					name
					birthDate
					email
				}
				profGroupId
				bevoegdGezag {
					naam
					nummer
				}
				functie {
					id
					naam
				}
				startDatum
				einddatum
				datumToegevoegd
				datumLaatsteWijziging
				vestiging {
					naam
					nummer
				}
			}
			totalCount
			pageInfo {
				hasNextPage
				hasPreviousPage
			}
		}
	}`
    const client = await util.createUrqlClient('/srpo/graphql')
    const opties = {
      skip: 0,
      take: 1000,
      where: where
    }
    client
      .query(query, opties)
      .toPromise()
      .then(data => {
        state.loading = false
        if (data.error === undefined) {
          let dataTable
          if (state.role.schoolleider) {
            dataTable = data.data.overeenkomsten.items.map(d => {
              var { bevoegdGezag, functie, startDatum, einddatum, vestiging, id } = d
              return {
                bestuur: bevoegdGezag && bevoegdGezag.naam,
                bevoegdGezagNummer: bevoegdGezag && bevoegdGezag.nummer,
                functie: functie && functie.naam,
                startDatum,
                einddatum,
                vestiging: vestiging.map(v => ({
                  value: v.nummer,
                  labelText: v.naam
                })),
                id
              }
            })
          }
          if (state.role.beheerder) {
            dataTable = data.data.overeenkomsten.items.map(d => {
              var { bevoegdGezag, person, functie, startDatum, einddatum, vestiging, id } = d
              return {
                bestuur: bevoegdGezag && bevoegdGezag.naam,
                bevoegdGezagNummer: bevoegdGezag && bevoegdGezag.nummer,
                person: person && person.name + ' (' + person.regNr + ')',
                geboortedatum: person && person.birthDate,
                functie: functie && functie.naam,
                startDatum,
                einddatum,
                vestiging: vestiging.map(v => ({
                  value: v.nummer,
                  labelText: v.naam
                })),
                id
              }
            })
          }
          if (state.role.bestuurder) {
            dataTable = data.data.overeenkomsten.items.map(d => {
              var { person, functie, startDatum, einddatum, vestiging } = d
              return {
                status: person && person.status,
                herregistratiedatum: person && person.herregDate,
                person: person && person.name,
                geboortedatum: person && person.birthDate,
                email: person && person.email,
                functie: functie && functie.naam,
                startDatum,
                einddatum,
                vestiging: vestiging.map(v => ({
                  value: v.nummer,
                  labelText: v.naam
                }))
              }
            })
          }
          commit('setXVtabledata', dataTable)
          commit('initXVtableState', state.srpoTable)
          commit('setXVtableColumnsettings')
          if (state.role.bestuurder) {
            commit('setExtraColumsettingsBestuur')
            commit('setExtraColumsettingsGeboorteDatum')
            commit('sortColumnSettings')
          }
          if (state.role.beheerder) {
            commit('setExtraColumsettingsGeboorteDatum')
            commit('sortColumnSettings')
          }
          commit('setXVtablesetting')
          commit('setVestigingString')
        }
      })
  },
  getResetFilters: async ({ dispatch, commit }) => {
    commit('resetFilterInput')
    dispatch('getTableData')
  },
  getConceptTableData: async ({ commit }) => {
    const query = `query OvereenkomstSRPOQuery($id: Int) {
    conceptOvereenkomsten(id:$id){
        id
        voorletters
        tussenvoegsel 
        achternaam
        geboortedatum
        email
        functie {
          naam
          id
        }
        startDatum
      }
    }
  `
    const client = await util.createUrqlClient('/srpo/graphql')
    const opties = {}
    client
      .query(query, opties)
      .toPromise()
      .then(data => {
        if (data.error === undefined) {
          let dataTable = data.data.conceptOvereenkomsten.map(d => {
            var { voorletters, tussenvoegsel, achternaam, geboortedatum, email, functie, startDatum, id } = d
            let person = voorletters
            if (tussenvoegsel) {
              person += ' ' + tussenvoegsel
            }
            person += ' ' + achternaam
            return {
              id: id,
              person: person,
              voorletters,
              tussenvoegsel,
              achternaam,
              geboortedatum,
              email,
              functie: functie && functie.naam,
              functieId: functie && functie.id,
              startDatum
            }
          })
          commit('setXVtabledataConcepten', dataTable)
          commit('conceptInitXVtableState', state.srpoTableConcepten)
          commit('setXVtableColumnsettingsConcepten')
          commit('setXVtablesettingConcepten')
        }
      })
  },
  getBestuurEnFuncties: async ({ commit }) => {
    const query = `query OvereenkomstSRPOQuery {
      bevoegdGezagen{
      nummer
      naam
      }
      functies{
      id
      naam
      }
    }
    `
    const client = await util.createUrqlClient('/srpo/graphql')
    const opties = {}
    client
      .query(query, opties)
      .toPromise()
      .then(data => {
        commit('setBestuurEnFuncties', data.data)
      })
  },
  getVestigingen: async ({ commit }) => {
    const query = `query OvereenkomstSRPOQuery($bevoegdGezagNummer: String!) {
      vestigingen(bevoegdGezagNummer: $bevoegdGezagNummer){
        bevoegdGezagNummer
        naam
        nummer
      } 
    }
    `
    const client = await util.createUrqlClient('/srpo/graphql')
    const opties = {
      bevoegdGezagNummer: state.formInput.msBestuur.value
    }
    client
      .query(query, opties)
      .toPromise()
      .then(data => {
        commit('setVestigingen', data.data.vestigingen)
      })
  },
  resetSelectedVestigingen({ commit }) {
    commit('resetSelectedVestigingenState')
  },
  getVestigingenWijzig: async ({ commit }, row) => {
    const query = `query OvereenkomstSRPOQuery($bevoegdGezagNummer: String!) {
      vestigingen(bevoegdGezagNummer: $bevoegdGezagNummer){
        bevoegdGezagNummer
        naam
        nummer
      } 
    }
    `
    const client = await util.createUrqlClient('/srpo/graphql')
    const opties = {
      bevoegdGezagNummer: row.bevoegdGezagNummer
    }
    client
      .query(query, opties)
      .toPromise()
      .then(data => {
        commit('setVestigingenWijzig', { data: data.data.vestigingen, row: row })
      })
  },
  insertOvereenkomst: async ({ commit, rootState, dispatch }, inputdata) => {
    const output = await util.postData('api/v1/SRPO/Overeenkomst', inputdata)
    if (Object.keys(output).length !== 0) {
      commit(
        'addNotification',
        {
          groupname: 'primary',
          message: rootState.translation[149]
        },
        { root: true }
      )
      router.push({ name: 'overzicht' })
    }
    commit('toggleBtnOpslaan', false)
  },
  updateOvereenkomst: async ({ commit, rootState, dispatch }, inputdata) => {
    const output = await util.putData('api/v1/SRPO/Overeenkomst', inputdata)
    if (Object.keys(output).length !== 0) {
      dispatch('getTableData')
      commit(
        'addNotification',
        {
          groupname: 'primary',
          message: rootState.translation[149]
        },
        { root: true }
      )
    }
    commit('toggleBtnWijziging', false)
  },
  deleteOvereenkomst: async ({ commit, rootState, dispatch }, id) => {
    await util.deleteData('api/v1/SRPO/Overeenkomst', id).then(() => {
      state.srpoTable.tabledata = state.srpoTable.tabledata.filter(function(obj) {
        return obj.id !== id
      })
      state.pageSettings.selectedOvereenkomstId = 0
      dispatch('getTableData')
      commit('addNotification', { groupname: 'warning', message: rootState.translation[16885] }, { root: true })
    })
    commit('toggleBtnVerwijder', false)
  },
  insertOvereenkomstConcept: async ({ commit, rootState, dispatch }, inputdata) => {
    const output = await util.postData('api/v1/SRPO/ConceptOvereenkomst', inputdata)
    if (Object.keys(output).length !== 0) {
      commit(
        'addNotification',
        {
          groupname: 'primary',
          message: rootState.translation[149]
        },
        { root: true }
      )
      router.push({ name: 'overzicht' })
    }
    commit('toggleBtnOpslaanConcept', false)
  },
  updateOvereenkomstConcept: async ({ commit, rootState }, inputdata) => {
    const output = await util.putData('api/v1/SRPO/ConceptOvereenkomst', inputdata)
    if (Object.keys(output).length !== 0) {
      commit(
        'addNotification',
        {
          groupname: 'primary',
          message: rootState.translation[149]
        },
        { root: true }
      )
      router.push({ name: 'overzicht' })
    }
    commit('toggleBtnWijzigingConcept', false)
  },
  deleteConceptOvereenkomst: async ({ commit, rootState, dispatch }, id) => {
    const output = await util.deleteData('api/v1/SRPO/ConceptOvereenkomst', id)
    if (output === 200) {
      state.pageSettings.selectedConceptOvereenkomstId = 0
      dispatch('getConceptTableData')
      commit(
        'addNotification',
        {
          groupname: 'warning',
          message: rootState.translation[16885]
        },
        { root: true }
      )
    }
    commit('toggleBtnVerwijderConcept', false)
  },
  stuurBericht: async ({ commit, rootState }, inputdata) => {
    const output = await util.postData('api/v1/SRPO/MessageBevoegdGezag', inputdata)
    if (Object.keys(output).length !== 0) {
      commit(
        'addNotification',
        {
          groupname: 'primary',
          message: rootState.translation[16884]
        },
        { root: true }
      )
      router.push({ name: 'overzicht' }).then(() => {
        state.formInputMessage = { ...formInputMessage }
      })
    }
    commit('toggleBtnVerstuur', false)
  }
}

// mutations
const mutations = {
  ...setXVtableMutations('srpoTable'),
  conceptXVtableSetRowStateProperty: XVtableSetRowStateProperty('srpoTableConcepten'),
  conceptXVTablesort: XVTablesort('srpoTableConcepten'),
  conceptXVtablecolumnsettingchanged: XVtablecolumnsettingchanged('srpoTableConcepten'),
  conceptInitXVtableState: initXVtableState('srpoTableConcepten'),
  conceptAddXVtableState: addXVtableState('srpoTableConcepten'),
  setStateOfRow(state, rowToSet) {
    state.srpoTable.tabledata[rowToSet.storeTableindex] = rowToSet
  },
  setXVtabledata(state, tabledata) {
    state.srpoTable.tabledata = tabledata

    let einddatumLeeg = state.srpoTable.tabledata.filter(row => row.einddatum === null)
    if (einddatumLeeg.length >= 1) {
      state.pageSettings.actieveOvereenkomst = true
    } else {
      state.pageSettings.actieveOvereenkomst = false
    }
  },
  setVestigingString(state) {
    state.srpoTable.tabledata.forEach((row, index) => {
      Vue.set(row, 'tableRowState', {
        rowVisible: false,
        editModus: false,
        storeTableindex: index,
        vestigingString: '',
        vestigingenWijzigData: [],
        WijzigDatumSelected: null,
        wijzigVestigingSelected: [],
        cbWijzigSchoolvestigingNA: false
      })
    })
    state.srpoTable.tabledata.forEach(r => {
      if (r.vestiging.length >= 1) {
        let vestigingString = []
        r.vestiging.forEach(v => {
          vestigingString.push(v.labelText + ' (' + v.value + ')')
        })
        vestigingString = vestigingString.join(', ')
        Vue.set(r.tableRowState, 'vestigingString', vestigingString)
      } else {
        Vue.set(r.tableRowState, 'cbWijzigSchoolvestigingNA', true)
      }
    })
  },
  setXVtabledataConcepten(state, tabledata) {
    state.srpoTableConcepten.tabledata = tabledata
  },
  setRole(state) {
    if (util.UgetCookie('pe_UserInRole') === 'PR') {
      state.role.schoolleider = true
      state.role.beheerder = false
      state.role.bestuurder = false
    } else if (util.UgetCookie('pe_UserInRole') === 'BH') {
      var subroles = util
        .UgetCookie('pe_Subroles')
        .split(',')
        .map(Number)
      subroles.forEach(s => {
        if (s === 6) {
          state.role.schoolleider = false
          state.role.beheerder = true
          state.role.bestuurder = false
        }
        if (s === 24) {
          state.role.schoolleider = false
          state.role.beheerder = false
          state.role.bestuurder = true
        }
      })
    }
  },
  showConfirm(state, bool) {
    state.pageSettings.showConfirm = bool
  },
  showConfirmVerwijder(state, bool) {
    state.pageSettings.showConfirmVerwijder = bool
  },
  showConfirmConceptVerwijder(state, bool) {
    state.pageSettings.showConfirmConceptVerwijder = bool
  },
  resetFilterInput(state) {
    state.filterInput.registered = ''
    state.filterInput.bestuur = ''
    state.filterInput.iBirthDate = null
    state.srpoTable.tablesetting = {}
    state.srpoTable.tablecolumnsetting = []
    state.srpoTable.tabledata = []
  },
  clearDetail(state) {
    state.formInput = {
      msBestuur: {},
      rbFunctie: null,
      iStartDatum: null,
      iEindDatum: null,
      cbSchoolvestigingNietAanwezig: false,
      msSchoolvestiging: []
    }
  },
  clearDetailConcept(state) {
    state.formInputConcept = {
      tbxVoorletters: '',
      tbxTussenvoegsel: '',
      tbxAchternaam: '',
      tbxEmail: '',
      iGeboortedatum: null,
      rbFunctie: null,
      iStartDatum: null
    }
  },
  fillDataConceptOvereenkomst(state, id) {
    let conceptOvereenkomst = state.srpoTableConcepten.tabledata.filter(r => {
      return r.id === parseInt(id, 10)
    })[0]
    if (conceptOvereenkomst) {
      state.formInputConcept = {
        tbxVoorletters: conceptOvereenkomst.voorletters,
        tbxTussenvoegsel: conceptOvereenkomst.tussenvoegsel,
        tbxAchternaam: conceptOvereenkomst.achternaam,
        tbxEmail: conceptOvereenkomst.email,
        iGeboortedatum: new Date(conceptOvereenkomst.geboortedatum),
        rbFunctie: conceptOvereenkomst.functieId,
        iStartDatum: new Date(conceptOvereenkomst.startDatum)
      }
    } else {
      const query = `
      query OvereenkomstSRPOQuery($id: Int) {
        conceptOvereenkomsten(id:$id){
            id
            voorletters
            tussenvoegsel 
            achternaam
            geboortedatum
            email
            functie {
              naam
              id
            }
            startDatum
          }
        }
      `
      util.createUrqlClient('/srpo/graphql').then((client) => {
        const opties = {
          id
        }
        client
          .query(query, opties)
          .toPromise()
          .then(data => {
            if (data.error === undefined) {
              const conceptOvereenkomst = data.data.conceptOvereenkomsten[0]
              state.formInputConcept = {
                tbxVoorletters: conceptOvereenkomst.voorletters,
                tbxTussenvoegsel: conceptOvereenkomst.tussenvoegsel,
                tbxAchternaam: conceptOvereenkomst.achternaam,
                tbxEmail: conceptOvereenkomst.email,
                iGeboortedatum: new Date(conceptOvereenkomst.geboortedatum),
                rbFunctie: conceptOvereenkomst.functie.id,
                iStartDatum: new Date(conceptOvereenkomst.startDatum)
              }
            }
          })
      })
    }
  },
  setBestuurEnFuncties(state, data) {
    state.bevoegdGezagenData = data.bevoegdGezagen
    state.functieData = data.functies
  },
  setVestigingen(state, data) {
    state.vestigingenData = data
  },
  resetSelectedVestigingenState(state) {
    state.formInput.msSchoolvestiging = []
  },
  toggleBtnOpslaan(state, bool) {
    state.btnToggles.btnOpslaan = bool
  },
  toggleBtnWijziging(state, bool) {
    state.btnToggles.btnWijziging = bool
  },
  toggleBtnOpslaanConcept(state, bool) {
    state.btnToggles.btnOpslaanConcept = bool
  },
  toggleBtnWijzigingConcept(state, bool) {
    state.btnToggles.btnWijzigingConcept = bool
  },
  toggleBtnVerstuur(state, bool) {
    state.btnToggles.btnVerstuur = bool
  },
  toggleBtnVerwijder(state, bool) {
    state.btnToggles.btnVerwijder = bool
  },
  toggleBtnVerwijderConcept(state, bool) {
    state.btnToggles.btnVerwijderConcept = bool
  },
  setVestigingenWijzig(state, { data, row }) {
    let vestigingenwijzigdata = data.map(v => ({
      value: v.nummer,
      labelText: v.naam
    }))
    state.srpoTable.tabledata.forEach(r => {
      if (r.tableRowState.storeTableindex === row.tableRowState.storeTableindex) {
        Vue.set(r.tableRowState, 'vestigingenWijzigData', vestigingenwijzigdata)
      } else {
        Vue.set(r.tableRowState, 'vestigingenWijzigData', [])
      }
    })
  },
  sortColumnSettings(state) {
    state.srpoTable.tablecolumnsetting.sort((a, b) => (a.sequence > b.sequence ? 1 : -1))
  },
  setXVtablesetting(state) {
    state.srpoTable.tablesetting = {
      AlwaysShowDetail: null,
      tableName: 'overeenkomsten',
      paging: 1,
      pagingSize: 49,
      procedure: 'srpoTable',
      sequence: 1,
      sortable: 1
    }
  },
  setXVtablesettingConcepten(state) {
    state.srpoTableConcepten.tablesetting = {
      AlwaysShowDetail: null,
      tableName: 'conceptOvereenkomsten',
      paging: 1,
      pagingSize: 49,
      procedure: 'srpoTableConcepten',
      sequence: 1,
      sortable: 1
    }
  },
  setXVtableColumnsettings(state) {
    state.srpoTable.tablecolumnsetting = [
      {
        columnname: '',
        helpTextID: null,
        name: 'wijzig',
        headerTextID: 0,
        sequence: 0,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        type: 'string',
        visible: 0,
        visibleMD: 1,
        visibleSM: 0,
        visibleXS: 0,
        widthMD: '30px',
        widthSM: '30px',
        widthXS: null,
        tableName: 'overeenkomsten',
        procedure: 'srpoTable'
      },
      {
        columnname: '',
        helpTextID: null,
        name: 'verwijder',
        headerTextID: 0,
        sequence: 1,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        type: 'string',
        visible: 0,
        visibleMD: 1,
        visibleSM: 0,
        visibleXS: 0,
        widthMD: '30px',
        widthSM: '30px',
        widthXS: null,
        tableName: 'overeenkomsten',
        procedure: 'srpoTable'
      },
      {
        columnname: store.getters.translation(16878),
        helpTextID: null,
        name: 'bestuur',
        headerTextID: null,
        sequence: 2,
        sortColumn: 'bestuur',
        sortable: 1,
        sortableDefault: 0,
        type: 'string',
        visible: 0,
        visibleMD: '200px',
        visibleSM: 1,
        visibleXS: 1,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'overeenkomsten',
        procedure: 'srpoTable'
      },
      {
        columnname: store.getters.translation(16888),
        helpTextID: null,
        name: 'status',
        headerTextID: null,
        sequence: 3,
        sortColumn: 'status',
        sortable: 1,
        sortableDefault: 0,
        type: 'string',
        visible: 0,
        visibleMD: 1,
        visibleSM: 0,
        visibleXS: 0,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'overeenkomsten',
        procedure: 'srpoTable'
      },
      {
        columnname: store.getters.translation(16889),
        helpTextID: null,
        name: 'person',
        headerTextID: null,
        sequence: 5,
        sortColumn: 'person',
        sortable: 1,
        sortableDefault: 0,
        type: 'string',
        visible: 0,
        visibleMD: 1,
        visibleSM: 1,
        visibleXS: 1,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'overeenkomsten',
        procedure: 'srpoTable'
      },
      {
        columnname: store.getters.translation(16868),
        helpTextID: null,
        name: 'email',
        headerTextID: null,
        sequence: 7,
        sortColumn: 'email',
        sortable: 1,
        sortableDefault: 0,
        type: 'string',
        visible: 0,
        visibleMD: 1,
        visibleSM: 0,
        visibleXS: 0,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'overeenkomsten',
        procedure: 'srpoTable'
      },
      {
        columnname: store.getters.translation(16870),
        helpTextID: null,
        name: 'functie',
        headerTextID: null,
        sequence: 9,
        sortColumn: 'functie',
        sortable: 1,
        sortableDefault: 0,
        type: 'string',
        visible: 0,
        visibleMD: 1,
        visibleSM: 1,
        visibleXS: 1,
        widthMD: '105px',
        widthSM: null,
        widthXS: null,
        tableName: 'overeenkomsten',
        procedure: 'srpoTable'
      },
      {
        columnname: store.getters.translation(16846),
        helpTextID: null,
        name: 'startDatum',
        headerTextID: null,
        sequence: 10,
        sortColumn: 'startDatum',
        sortable: 1,
        sortableDefault: 0,
        type: 'date',
        visible: 0,
        visibleMD: 1,
        visibleSM: 1,
        visibleXS: 0,
        widthMD: '105px',
        widthSM: null,
        widthXS: null,
        tableName: 'overeenkomsten',
        procedure: 'srpoTable'
      },
      {
        columnname: store.getters.translation(16847),
        helpTextID: null,
        name: 'einddatum',
        headerTextID: null,
        sequence: 11,
        sortColumn: 'einddatum',
        sortable: 1,
        sortableDefault: 0,
        type: 'date',
        visible: 0,
        visibleMD: 1,
        visibleSM: 1,
        visibleXS: 0,
        widthMD: '105px',
        widthSM: null,
        widthXS: null,
        tableName: 'overeenkomsten',
        procedure: 'srpoTable'
      },
      {
        columnname: store.getters.translation(16849),
        helpTextID: null,
        name: 'vestiging',
        headerTextID: null,
        sequence: 12,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        type: 'string',
        visible: 0,
        visibleMD: 1,
        visibleSM: 0,
        visibleXS: 0,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'overeenkomsten',
        procedure: 'srpoTable'
      },

      {
        columnname: '',
        helpTextID: null,
        name: 'bevoegdGezagNummer',
        headerTextID: null,
        sequence: 13,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        type: 'string',
        visible: 0,
        visibleMD: 0,
        visibleSM: 0,
        visibleXS: 0,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'overeenkomsten',
        procedure: 'srpoTable'
      },

      {
        columnname: 'id',
        helpTextID: null,
        name: 'id',
        headerTextID: null,
        sequence: 14,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        type: null,
        visible: 0,
        visibleMD: null,
        visibleSM: null,
        visibleXS: null,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'overeenkomsten',
        procedure: 'srpoTable'
      },
      {
        columnname: 'tableRowState',
        helpTextID: null,
        name: 'tableRowState',
        headerTextID: null,
        sequence: 15,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        type: null,
        visible: 0,
        visibleMD: null,
        visibleSM: null,
        visibleXS: null,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'overeenkomsten',
        procedure: 'srpoTable'
      }
    ]
  },
  setExtraColumsettingsBestuur(state) {
    state.srpoTable.tablecolumnsetting.push({
      columnname: store.getters.translation(16890),
      helpTextID: null,
      name: 'herregistratiedatum',
      headerTextID: null,
      sequence: 4,
      sortColumn: 'herregistratiedatum',
      sortable: 1,
      sortableDefault: 0,
      type: 'date',
      visible: 0,
      visibleMD: 1,
      visibleSM: 0,
      visibleXS: 0,
      widthMD: null,
      widthSM: null,
      widthXS: null,
      tableName: 'overeenkomsten',
      procedure: 'srpoTable'
    })
  },
  setExtraColumsettingsGeboorteDatum(state) {
    state.srpoTable.tablecolumnsetting.push({
      columnname: store.getters.translation(16869),
      helpTextID: null,
      name: 'geboortedatum',
      headerTextID: null,
      sequence: 6,
      sortColumn: 'geboortedatum',
      sortable: 1,
      sortableDefault: 0,
      type: 'date',
      visible: 0,
      visibleMD: 1,
      visibleSM: 0,
      visibleXS: 0,
      widthMD: '115px',
      widthSM: null,
      widthXS: null,
      tableName: 'overeenkomsten',
      procedure: 'srpoTable'
    })
  },
  setXVtableColumnsettingsConcepten(state) {
    state.srpoTableConcepten.tablecolumnsetting = [
      {
        columnname: '',
        helpTextID: null,
        name: 'wijzig',
        headerTextID: 0,
        sequence: 0,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        type: 'string',
        visible: 1,
        visibleMD: 1,
        visibleSM: 0,
        visibleXS: 0,
        widthMD: '30px',
        widthSM: '30px',
        widthXS: null,
        tableName: 'conceptOvereenkomsten',
        procedure: 'srpoTableConcepten'
      },
      {
        columnname: '',
        helpTextID: null,
        name: 'verwijder',
        headerTextID: 0,
        sequence: 1,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        type: 'string',
        visible: 1,
        visibleMD: 1,
        visibleSM: 0,
        visibleXS: 0,
        widthMD: '30px',
        widthSM: '30px',
        widthXS: null,
        tableName: 'conceptOvereenkomsten',
        procedure: 'srpoTableConcepten'
      },
      {
        columnname: store.getters.translation(16889),
        helpTextID: null,
        name: 'person',
        headerTextID: null,
        sequence: 2,
        sortColumn: 'person',
        sortable: 1,
        sortableDefault: 0,
        type: 'string',
        visible: 1,
        visibleMD: 1,
        visibleSM: 1,
        visibleXS: 1,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'conceptOvereenkomsten',
        procedure: 'srpoTableConcepten'
      },
      {
        columnname: store.getters.translation(16869),
        helpTextID: null,
        name: 'geboortedatum',
        headerTextID: null,
        sequence: 3,
        sortColumn: 'geboortedatum',
        sortable: 1,
        sortableDefault: 0,
        type: 'date',
        visible: 1,
        visibleMD: 1,
        visibleSM: 1,
        visibleXS: 1,
        widthMD: '115px',
        widthSM: null,
        widthXS: null,
        tableName: 'conceptOvereenkomsten',
        procedure: 'srpoTableConcepten'
      },
      {
        columnname: store.getters.translation(16868),
        helpTextID: null,
        name: 'email',
        headerTextID: null,
        sequence: 4,
        sortColumn: 'email',
        sortable: 1,
        sortableDefault: 0,
        type: 'string',
        visible: 1,
        visibleMD: 1,
        visibleSM: 0,
        visibleXS: 0,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'conceptOvereenkomsten',
        procedure: 'srpoTableConcepten'
      },
      {
        columnname: store.getters.translation(16870),
        helpTextID: null,
        name: 'functie',
        headerTextID: null,
        sequence: 5,
        sortColumn: 'functie',
        sortable: 1,
        sortableDefault: 0,
        type: 'string',
        visible: 1,
        visibleMD: 1,
        visibleSM: 0,
        visibleXS: 0,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'conceptOvereenkomsten',
        procedure: 'srpoTableConcepten'
      },
      {
        columnname: store.getters.translation(16871),
        helpTextID: null,
        name: 'startDatum',
        headerTextID: null,
        sequence: 6,
        sortColumn: 'startDatum',
        sortable: 1,
        sortableDefault: 0,
        type: 'date',
        visible: 1,
        visibleMD: 1,
        visibleSM: 0,
        visibleXS: 0,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'conceptOvereenkomsten',
        procedure: 'srpoTableConcepten'
      },
      {
        columnname: '',
        helpTextID: null,
        name: 'id',
        headerTextID: null,
        sequence: 7,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        type: 'number',
        visible: 0,
        visibleMD: 0,
        visibleSM: 0,
        visibleXS: 0,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'conceptOvereenkomsten',
        procedure: 'srpoTableConcepten'
      },
      {
        columnname: '',
        helpTextID: null,
        name: 'functieId',
        headerTextID: null,
        sequence: 8,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        type: 'number',
        visible: 0,
        visibleMD: 0,
        visibleSM: 0,
        visibleXS: 0,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'conceptOvereenkomsten',
        procedure: 'srpoTableConcepten'
      },
      {
        columnname: '',
        helpTextID: null,
        name: 'voorletters',
        headerTextID: null,
        sequence: 9,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        type: 'string',
        visible: 0,
        visibleMD: 0,
        visibleSM: 0,
        visibleXS: 0,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'conceptOvereenkomsten',
        procedure: 'srpoTableConcepten'
      },
      {
        columnname: '',
        helpTextID: null,
        name: 'tussenvoegsel',
        headerTextID: null,
        sequence: 10,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        type: 'string',
        visible: 0,
        visibleMD: 0,
        visibleSM: 0,
        visibleXS: 0,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'conceptOvereenkomsten',
        procedure: 'srpoTableConcepten'
      },
      {
        columnname: '',
        helpTextID: null,
        name: 'achternaam',
        headerTextID: null,
        sequence: 11,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        type: 'string',
        visible: 0,
        visibleMD: 0,
        visibleSM: 0,
        visibleXS: 0,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'conceptOvereenkomsten',
        procedure: 'srpoTableConcepten'
      },
      {
        columnname: 'tableRowState',
        helpTextID: null,
        name: 'tableRowState',
        headerTextID: null,
        sequence: 12,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        type: null,
        visible: 0,
        visibleMD: null,
        visibleSM: null,
        visibleXS: null,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'conceptOvereenkomsten',
        procedure: 'srpoTableConcepten'
      }
    ]
  }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
